// UI
import { cn } from "@/lib/utils"
import { Heading } from "@/components/Typography"

/**
 * OverallStatsBlock
 * @param param0
 * @returns
 */
export function OverallStatsBlock({
	title,
	stats,
	explanation,
	loading = false,
}: {
	title: string
	stats: string
	explanation?: string
	loading?: boolean
}) {
	return (
		<>
			<div className="h-full transition-all duration-200">
				<div
					className={cn(
						"flex h-full flex-col justify-center rounded-xs border border-transparent bg-white px-4 py-5 text-center shadow sm:rounded-lg sm:p-6",
					)}
				>
					{loading ? (
						<>
							<div className="animate-pulse">
								<div
									className="mx-auto mb-2 h-8 w-24 rounded bg-gray-200"
									data-testid="stats-skeleton"
								></div>
								<div
									className="mx-auto h-4 w-32 rounded bg-gray-200"
									data-testid="title-skeleton"
								></div>
							</div>
						</>
					) : (
						<>
							<Heading
								as="h3"
								styleAs="h4"
								className="text-brandgray-700"
							>
								{stats}
							</Heading>
							<div className="flex items-center justify-center gap-2 text-gray-400">
								<div>{title}</div>
							</div>
							{explanation ? <div>{explanation}</div> : null}
						</>
					)}
				</div>
			</div>
		</>
	)
}
